

import './CompanyProfile.css';

import useGetByID from "../../CustomeHooks/useGetByID";
import FileUploader from '../Uploader/FileUploader';

import { Link, useParams, Navigate, useNavigate, useLocation } from 'react-router-dom';

import { useToast } from '../../CustomeHooks/useToast';
import { useEffect, useRef, useState } from 'react';

import Cookie from 'js-cookie';
import axios from "axios";

import validator from 'validator';


//import ReactQuill from 'react-quill'; // old code
//import "react-quill/dist/quill.snow.css";  // old code

//https://www.youtube.com/watch?v=BvMvwsCQt1c  use react-quill and not react-quill-new
//https://www.npmjs.com/package/react-quill-new
import ReactQuill from 'react-quill-new'; // new code
import "react-quill-new/dist/quill.snow.css";  // new code


import { isValidToken, sleep } from '../../Javascript_Functions_to_export/Utils';

//import $ from 'jquery';

const CompanyProfile = ({ setLogoFn }) => {

    const navigate = useNavigate();
    const toast = useToast();
    const location = useLocation();

    const { id } = useParams();
    const { lsData: currItem, isLoading, found, useEmailBody, useCompanyProfile } = 
    //useGetByID('http://localhost:808x/company/' + id);
    useGetByID(`${process.env.REACT_APP_URL}/company/${id}`);

    const [currCompany, setCurrCompany] = useState(null);

    const loggedInIconBase64 = "data:@file/png;base64,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"; 

    useEffect(() => {

        // axios.get(`${process.env.REACT_APP_URL}/touch_session`)
        // .then(res => {
        //     console.log("sessionEnded=", res.data.sessionEnded, "expire=", res.data.expire);
        //     if(res.data.sessionEnded && res.data.sessionEnded === true) {
        //         console.log("should logout");
        //         alert("Session has expired.")
        //         if(localStorag.getItem('Logo'))
        //             localStorag.removeItem('Logo');
        //         window.location.href = process.env.REACT_APP_ORIGI + "/login";
        //     }
        // });

        setCurrCompany(currItem);
        //alert(useEmailBody);
        setEmailBody(useEmailBody ? useEmailBody : '');
        setProfile(useCompanyProfile ? useCompanyProfile : '');

        //console.log("company = ", currItem);
        if(currItem) {
            //console.log("Setting Logo");
            sessionStorage.setItem('Logo', currItem.Logo);   // this one is innocent
        }
        //setLogoFn(currItem.Logo);   // old code

    }, [currItem])

    useEffect(() => {
        
        //console.log("in useEffect hook");
        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        // If user closes the tab || 
        //         closes the browser ||
        //         or open a new tab
        // before the session expired
        // if(_token && !sessionStorage.getItem('Logo')) {
        //     axios.get(`${process.env.REACT_APP_URL}/logout`, { withCredentials: true })
        //     .then(res => {
        //         if(sessionStorage.getItem('Logo'))
        //             sessionStorage.removeItem('Logo');

        //         window.location.href = process.env.REACT_APP_ORIGI + "/login";
        //     })
        //     .catch(err => {
        //         toast('error', err.response.data.message);
        //     })
        // }

        // user navigate to this page manually (using url)
        if(!location.state && !Cookie.get('token') && !Cookie.get('adminToken')) {
            toast('warning', 'Please login first !');
            if(sessionStorage.getItem('Logo'))
                sessionStorage.removeItem('Logo');
            //navigate('/login');
            // use this line instead of navigate, because it could the cookie expired, 
            // so we need to reload the page to remove the companyLogo
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
        }
        else {
            // user already was in "CompanyProfile" page, and clicks "Logout"
            if(location && location.state && location.state.LastVisitedPage.indexOf("/company/details/") >= 0 && 
               !Cookie.get('token') && !Cookie.get('adminToken')) {
                if(sessionStorage.getItem('Logo'))
                    sessionStorage.removeItem('Logo');
                //navigate('/login');
                window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            }
        }

        //disablePaste();

        window.scrollTo(0, 0);

    }, []);

    // const timeOuts = useRef([]);

    // const disablePaste = () => {
    //     if(document.getElementById("react-quill-company-profile")) {
    //         //clearTimeout();
    //         document.getElementById("react-quill-company-profile").addEventListener("paste", function(e) {
    //             toast("warning", "Pasting is not allowed !");
    //             for (let j = 0; j < timeOuts.length; j++) {
    //                 clearTimeout(timeOuts[j]);
                    
    //             }
    //             timeOuts.current = [];
    //             e.preventDefault();
    //         });
    //     }
    //     else {
    //         timeOuts.current.push(setTimeout(() => {
    //             console.log("waiting for react-quill-company-profile");
    //             disablePaste();
    //         }, 50));
    //     }
    // }


    const [companyNameError, setCompanyNameError] = useState('');

    const _setCompanyName = (e) => {

        if(e && e.target) {
            if(e.target.value.trim().length === 0)
                setCompanyNameError('Company name is required');
            else
                setCompanyNameError('');

            setCurrCompany({...currCompany, CompanyName: e.target.value });
            //setCompanyName(e.target.value);
        }
    }
    
    const changeIsConfidential = (e) => {
        //console.log('e.target = ', e.target.checked);   // e.target.value : did not work
        //setConfidential(e.target.checked);

        if(e && e.target)
            setCurrCompany({...currCompany, IsConfidential: e.target.checked });
    };

    const [companyEmailError, setCompanyEmailError] = useState('');
    
    const _setCompanyEmail = (e) => {
        if(e && e.target) {
            if(e.target.value.trim().length === 0)
                setCompanyEmailError('Company email is required');
            else
                setCompanyEmailError('');

            setCurrCompany({...currCompany, Email: e.target.value });
        }
    }

    const _setLocation = (e) => {
        if(e && e.target)
            setCurrCompany({...currCompany, Location: e.target.value });
    }


    const _setEmailSubject = (e) => {
        if(e && e.target)
            //setEmailSubject(e.target.value);
            setCurrCompany({...currCompany, EmailSubject: e.target.value });
    }


    const [emailBody, setEmailBody] = useState('');
    const [profile, setProfile] = useState('');

    const [isSaving, setIsSaving] = useState(false);
    
    const _setProfile = (e) => {
        if(e && e.target) {
            setProfile(e.target.value);
        }
    }

    // link reference : https://quilljs.com/docs/modules/toolbar
    const _modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'list': 'ordered'}],
            //[{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'color': [] }, { 'background': [] }],
        ]
    };

    const [file, setFile] = useState();
    const [companyLogo64, setCompanyLogo64] = useState('');

    const x = (_files) => {
        
        if(_files && _files.length > 0) {
            
            setFile(_files[0]);

            var reader = new FileReader();
            reader.onloadend = function() {
                setCompanyLogo64(reader.result);
            }
            reader.readAsDataURL(_files[0]);
            userMakeAction.current = true;
        }
    }

    const userMakeAction = useRef(false);

    const removeLogoFile = () => {
        userMakeAction.current = true;

        setFile(null);
        //setBackUpLogo(currCompany.Logo);
        //setCurrCompany({...currCompany, Logo: null});
        setCurrCompany({...currCompany, Logo: loggedInIconBase64});
    }

    const [isAddingCV, setIsAddingCV] = useState(false);

    const getIsAddingCV = (_isAdding) => {
        setIsAddingCV(_isAdding);
    }

    axios.defaults.withCredentials = true;

    //const handleSubmit = async (e) => {
    const updateCompany = () => {

        //e.preventDefault();

        var _token = null;
        if(Cookie.get('token'))
            _token = Cookie.get('token');
        else if(Cookie.get('adminToken'))
            _token = Cookie.get('adminToken');

        // User already has logged in, BUT the cookie has expired
        if(!_token && sessionStorage.getItem('Logo')) {
            alert("Session has expired, please Login again");
            sessionStorage.removeItem('Logo');
            window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            return;
        }

        // User has changed or added the token by hand
        if(_token && !isValidToken(_token)) {
            return;
        }

        if(!currCompany) {
            toast("error", "Server error ! Company is null");
            return;
        }

        if(!currCompany.CompanyName || currCompany.CompanyName.trim() === '') {
            toast("warning", "Company Name is required !");  
            return;
        }

        if(!currCompany.Email || currCompany.Email.trim() === '') {
            toast("warning", "Company Email is required !");  
            return;
        }

        if(!validator.isEmail(currCompany.Email)) {
            toast("warning", "Invalid Email !");
            return;
        }
      
        setIsSaving(true);

        var currCompanyFormData = {} ;//new FormData();

        // fields to update cookie, to check if company can post jobs or not:
        //currCompanyFormData.append("ID", currCompany.ID);
        
        
        currCompanyFormData.ID = currCompany.ID;
        currCompanyFormData.Email = currCompany.Email;
        currCompanyFormData.Username = currCompany.Username;
        currCompanyFormData.AccountType = currCompany.AccountType;

        // For time being, I am not working with the token
        // if(document.cookie) {
        //     currCompanyFormData.token = getUserFromCookie(document.cookie).token;
        // }

        currCompanyFormData.CompanyName = currCompany.CompanyName;
        currCompanyFormData.IsConfidential = currCompany.IsConfidential === true || currCompany.IsConfidential === 1 ? "1": "0" ;
        currCompanyFormData.Location = currCompany.Location;
        //currCompanyFormData.append("EmailSubject", currCompany.EmailSubject);

        //console.log("emailBody = ", document.getElementById("react-quill-email-body").textContent.trim());  // XXX
        //document.getElementById("react-quill-email-body").style.fontFamily = "impact";
        //var x = document.getElementsByClassName("ql-editor")[0];

        //console.log("emailBody = ", x);  // XXX
        
        //document.getElementById("react-quill-email-body").innerHTML style.fontWeight = "normal";//arial,Impact,Charcoal,sans-serif";
        //var newBody = emailBody.split(' ');

        currCompanyFormData.EmailBody = emailBody;
        currCompanyFormData.Profile = profile; 

        //console.log("currCompanyFormData = ", currCompanyFormData);

        //return;

        if(!userMakeAction.current) {
            currCompanyFormData.updateLogoColumn = "false";
            //currCompanyFormData.currentLogo = currCompany.Logo;
            currCompanyFormData.companyLogo64 = currCompany.Logo;   // currCompany.Logo est sous forme de "Base64"
        }
        else {
            if(file) {  // user takes action : add a new logo
                currCompanyFormData.file = file;
                currCompanyFormData.updateLogoColumn = "true";
                currCompanyFormData.fileName = file.name;
                currCompanyFormData.companyLogo64 = companyLogo64;
            }
            else {  // user deletes the Logo and save
                    currCompanyFormData.updateLogoColumn = "true";
                    currCompanyFormData.fileName = 'empty';
                    currCompanyFormData.currentLogo = "null";
                    currCompanyFormData.companyLogo64 = loggedInIconBase64;
            }
        }
        //axios.put('http://localhost:808x/update_company', currCompanyFormData)

        

        // because the put request is not working on live version
        //await axios.put(`${process.env.REACT_APP_URL}/update_company`,     
        //await axios.put(`${process.env.REACT_APP_URL}/update_company`, currCompanyFormData)
        axios.post(`${process.env.REACT_APP_URL}/update_company`, currCompanyFormData)
            // ,{
            //     maxBodyLength: Infinity, 
            //     maxContentLength: Infinity,  //1000000,
                

            // }, {
            //     headers: {
            //         "Content-Type": "application/json",
            //         Accept: "application/json",
            //         "Access-Control-Allow-Origin": "*"
            //     }
            // })
        .then(res => {
            if(res.data.status === 'success') {
                toast('success', 'Saved.');
                
                //navigate('/company/details/' + id);
                //window.location.href = "http://localhost:XXXX/company/details/" + id;   // its problem is: the toast does not appear
                
                // if(!sessionStorage.getItem('Logo')){
                //     sessionStorage.setItem('Logo', res.data.uniqueFileName);
                // }

                //console.log("Setting Logo");
                sessionStorage.setItem('Logo', res.data.uniqueFileName);
                //Cookie.remove('token');
                //Cookie.set('token', JSON.stringify(res.data.user));
                setLogoFn(res.data.uniqueFileName);
            }
            else
                toast("error", res.data.message);
        })
        .catch(err => {
            console.log("err", err);
            // if(!err.response)
            //     toast("error", "Unexpected Error has occured !");
            // else { 
            //     if(err.response.status === 401) {
            //         toast("error", err.response.data.message);
            //     }
            // }
        })
        .finally(() => {
            setIsSaving(false);
        })
    }


    return(
        <div className="company-profile-container every-page-container">
                {
                    currCompany && 
                    // <form onSubmit={ (e) => handleSubmit(e) }>
                    <form>
                    <div className='page-container'>
                        <div className='title-section'>
                            <div className='title'>
                                <h2>Company Profile</h2>
                            </div>
                            <div className='path'>
                                <div className='home'>Menu</div>
                                <div className='circle'></div>
                                <div className='change-password'>Profile</div>
                            </div>
                        </div>

                        <div className='fields-section'>
                            <div className='row-wrap'>

                                <div className='logo-file-section'>
                                        <div className='diff-margin'>
                                            Company Logo
                                        </div> 
                                        <div style={{ position: 'relative' }}>
                                            <div style={{ position: 'absolute', left: '90px', top: '-14px' }}>
                                                { 
                                                    (file || 
                                                    (currCompany.Logo && currCompany.Logo !== loggedInIconBase64)) && 
                                                    // && <button onClick={ removeLogoFile }>Remove Logo</button>
                                                    <i className="fa fa-times"
                                                    // <i className="fa fa-trash-o"
                                                    aria-hidden="true" 
                                                    style={{ color: '#ff00007a', 
                                                             zIndex: '20', 
                                                             cursor: 'pointer', 
                                                             fontSize: '27px',
                                                             border: "solid 1px #ff00001c", }}
                                                    onClick={ removeLogoFile } ></i>
                                                }
                                            </div>

                                            <div style={{ zIndex: '2' }}>
                                                { 
                                                    !file &&
                                                    currCompany.Logo &&
                                                    (currCompany.Logo !== loggedInIconBase64) &&
                                                    <img src={currCompany.Logo} 
                                                            alt='company logo'
                                                            style={{ width: '120px', 
                                                                    //height: '110px',  old code
                                                                    height: '120px',
                                                                    borderRadius: '10px', }} /> 
                                                }
                                                {
                                                    file &&
                                                    <img id="tempLogo" 
                                                        src={file.URL} 
                                                        style={{ width: '120px', 
                                                            //height: '110px',  old code
                                                            height: '120px',
                                                            borderRadius: '10px', }}/>
                                                }
                                                {
                                                    //!file && !currCompany.Logo
                                                    !file && (currCompany.Logo === loggedInIconBase64) &&
                                                    <> 
                                                        <FileUploader XXX={ x } 
                                                            isAddingFn={ getIsAddingCV } 
                                                            disableFromParent = { isSaving }
                                                            id='file-uploader'
                                                            btnText='Add Logo'
                                                            _accept="image/png, image/jpeg, image/jpg" />

                                                        <i className="fa fa-picture-o" id="empty-company-logo"
                                                        aria-hidden="true"
                                                        style={{
                                                                width: '120px',
                                                                //height: '110px',  old code
                                                                height: '120px',
                                                                borderRadius: '10px',
                                                                fontSize: '110px',
                                                                opacity: '0.14',
                                                                marginTop: '-8px', }}>
                                                        </i>
                                                        {/* <div style={{ position: 'absolute', 
                                                                    top: '55px',
                                                                    left: '60px',
                                                                    color: '#c1c1c1',
                                                        }}>
                                                            No Image
                                                        </div> */}
                                                    </>
                                                }
                                            </div>
                                        </div>
                                </div>

                                <div className='btn-save-profile field-comp' id='div-save-profile' >
                                    
                                <input name='saveChanges'
                                        // type='submit' 
                                        type='button'
                                        onClick={ updateCompany } 
                                        className={`profile-btn-itself${ isSaving === true || isAddingCV === true ? ' disabled' : ''}`}
                                        value={ 
                                            isAddingCV === true ? 'Save' :
                                            isSaving === true ? 'Saving' : 
                                            'Save'
                                        } 
                                        // {`${ isSaving ? 'Saving' : 'Save'}`} 
                                        disabled={ isSaving === true || isAddingCV === true } />
                                    
                                    {/* { 
                                        <input name='saveChanges'
                                            type='submit' 
                                            className='profile-btn-itself'
                                            style={{ visibility: !isSaving ? 'visible' : 'hidden' }}
                                            value='Save' />
                                    } */}
                                </div>


                                <div className='company-name-section field-comp field-comp-pr'>
                                    <div className='comp-title'>
                                        Company Name <span style={{ color: 'red' }}>*</span>
                                    </div> 
                                    <div className='field-container'>
                                        <input type="text" 
                                                name='companyname'
                                                value={ currCompany.CompanyName || ''} 
                                                onChange={ _setCompanyName } 
                                                // placeholder= 'The official company name under which your business is registered' 
                                                placeholder= 'The official company name' 
                                                maxLength='50'
                                                className='input-itself' />       
                                    </div> 
                                </div>

                                <div className='company-confid-section field-comp field-comp-pl field-comp-pr'>
                                    <div className='comp-title'>
                                        Show company name as Confidential
                                    </div> 
                                    <div className='field-container' 
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            height: '55px' }}>
                                        <input type="checkbox"
                                                id="companyconfid_id"
                                                name='companyconfid'
                                                style={{ width: '20px', 
                                                        height: '20px', 
                                                        cursor: 'pointer'}}
                                                
                                                checked= { currCompany.IsConfidential }
                                                value={ currCompany.IsConfidential || ''} 
                                                onChange={ changeIsConfidential } />
                                        <label style={{ fontSize: '11px',
                                                       color: 'rgb(161 161 161)',
                                                       paddingLeft: '13px',
                                                        cursor: 'pointer' }}
                                                htmlFor='companyconfid_id'>
                                            If checked, 'Confidential' will appear instead of Company Name.
                                        </label> 
                                    </div> 
                                </div>
    
                                <div className='company-email-section field-comp field-comp-pl'>
                                    <div className='comp-title'>
                                        Company Email <span style={{ color: 'red' }}>*</span>
                                    </div> 
                                    <div className='field-container'>
                                        <input type="text"
                                                name='companyemail'
                                                className='input-itself'
                                                value={ currCompany.Email || ''} 
                                                maxLength='50'
                                                placeholder= 'The work company email'
                                                onChange={ _setCompanyEmail} />       
                                    </div> 
                                </div> 

                                <div className='company-location-section field-comp'>
                                    <div className='comp-title'>
                                        Company Location
                                    </div> 
                                    <div className='field-container'>
                                        <input type="text"
                                                name='companylocation'
                                                className='input-itself'
                                                // value={ currCompany.Location || ''}
                                                value={ currCompany.Location === 'null' ? '' : currCompany.Location }
                                                maxLength='60'
                                                placeholder= 'e.g Lebanon - Beirut'
                                                onChange={ _setLocation }  />   
                                    </div> 
                                </div>



                                {/* <div className='company-emailsubject-section field-comp field-comp-pl'>
                                    <div className='comp-title'>
                                        Email Subject
                                    </div> 
                                    <div className='field-container'>
                                        <input type="text"
                                                name='companyemailsubject'
                                                className='input-itself'
                                                value={ currCompany.EmailSubject || ''}
                                                maxLength='100'
                                                placeholder="The email subject that you will receive once someone applies for your job."
                                                onChange={ _setEmailSubject } />   
                                    </div> 
                                </div> */}



                                <div className='company-emailbody-section field-comp field-comp-pr'>
                                    <div className='comp-title'>
                                        Email body you will receive once a user applies for a job.
                                    </div> 
                                    <div className='field-container react-quill-div'>
                                        <ReactQuill 
                                            id="react-quill-email-body"
                                            theme="snow" 
                                            value={ emailBody ? emailBody : '' } 
                                            modules={_modules}
                                            onChange={ setEmailBody } 
                                            
                                            name="emailbody"
                                            placeholder="Dear hiring manager(s),&#10;I recently came 
                                            across your 'Job Title' job. &#10;My resume is attached 
                                            for your review.&#10;If you would like more 
                                            information regarding my qualifications for this position,
                                            please do not hesitate to reach out.&#10;&#10;Thank you so 
                                            much for your time and consideration for this position,and 
                                            I look forward to hearing from you soon.&#10;&#10;Sincerely," />
                                    </div> 
                                </div>

                                <div className='company-company-profile-section field-comp field-comp-pl'>
                                    <div className='comp-title'>
                                        Company Profile
                                    </div> 
                                    <div className='field-container react-quill-div'>
                                        <ReactQuill 
                                            id="react-quill-company-profile"
                                            theme="snow" 
                                            value={ profile ? profile : '' } 
                                            modules={_modules}
                                            onChange={ setProfile } // worked properly
                                            name="companyprofile"
                                            placeholder="Introduction of the business which aims to inform 
                                            the audience about your products and services." />
                                    </div> 
                                </div>

                                <div className='btn-save-profile field-comp' id='div-save-profile_2' >
                                    
                                    
                                <input name='saveChanges_2'
                                        // type='submit' 
                                        type='button'
                                        onClick={ updateCompany } 
                                        className={`profile-btn-itself${ isSaving === true || isAddingCV === true ? ' disabled' : ''}`}
                                        value={ 
                                            isAddingCV === true ? 'Save' :
                                            isSaving === true ? 'Saving' : 
                                            'Save'
                                        } 
                                        // {`${ isSaving ? 'Saving' : 'Save'}`} 
                                        disabled={ isSaving === true || isAddingCV === true } />
                                    
                                    {/* { 
                                        <input name='saveChanges_2'
                                            type='submit' 
                                            className='profile-btn-itself'
                                            style={{ visibility: !isSaving ? 'visible' : 'hidden' }}
                                            value='Save' />
                                    } */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="div-header">
                        Company Profile <span style={{color: 'red'}}> </span>
                    </div> */}
                    </form>
                }
            </div>);
}

export default CompanyProfile;

